import { render, staticRenderFns } from "./e-field-group-crumbs.vue?vue&type=template&id=72ecba92&scoped=true&lang=pug&"
import script from "./e-field-group-crumbs.vue?vue&type=script&lang=js&"
export * from "./e-field-group-crumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ecba92",
  null
  
)

export default component.exports